  //<!--<editor-fold desc="WEB端">-->
    // var intervalMainPictureAndHideText;
    var  WebMainPictureAndHideTextClickIndex = 0;

    // 获取圆圈元素
    function WebPictureAndHideTextOnClick(index){

        // 切换图片
        $(".WebHideAndShowPicture").css('opacity','0');
        $("#WebHideAndShowPicture-"+index).css('opacity','1');

        // 固定文本隐藏
        // $(".mobile_fixTextDiv").css('opacity','0');

        // $(".WebVideoDiv").css('display','none');
        // $(".mobile_fixTextDiv").slideUp(300);

        // videoListPause('WebPictureAndHideTextDiv_video','WebPictureAndHideTextDiv-videoPlayButtonMobile')

        // 下方文本显隐
        var slideStatus = $("#WebPahHideDecText-"+index).css('display');
        $(".HideTextListDiv .WebHideTextDiv .WebHideDecText").slideUp(300);
        // $(".HideTextListDiv .WebHideTextDiv .WebHideDecText").css('opacity','0');
        $(".WebPictureAndHideTextArrow").css('transform','rotate(0deg)');
        $('.WebPahPictureAndHideTextArrow_circle').attr('fill', 'none');
        $('.WebPahPictureAndHideTextArrow_path').attr('stroke','#5BC0F8');

        $(".WebShowHeadText").css('opacity','0');
        sleep(10).then(() => {
            $(".WebShowHeadText").css('display','none');
        })
        $(".WebHideHeadText").css('opacity','1');
        sleep(10).then(() => {
            $(".WebHideHeadText").css('display','flex');
        })

        // $(".hideHeadText").css('font-size',"1.042vw");

        if (slideStatus == 'none'){
            $("#WebPahHideDecText-"+index).slideDown(300);
            // $("#WebPahHideDecText-"+index).css('opacity','1');
            $("#WebPahPictureAndHideTextArrow-"+index).css('transform','rotate(180deg)');
            $("#WebPahPictureAndHideTextArrow_circle-"+index).attr('fill', '#5BC0F8');
            $("#WebPahPictureAndHideTextArrow_path-"+index).attr('stroke','#FFFFFF');

            $("#WebPahHideHeadText-"+index).css('opacity','0');
            sleep(10).then(() => {
                $("#WebPahHideHeadText-"+index).css('display','none');
                // $("#WebPictureAndHideTextDiv_videoDiv_"+index).css('display','flex')
            })

            $("#WebPahShowHeadText-"+index).css('opacity','1');
            sleep(10).then(() => {
                $("#WebPahShowHeadText-"+index).fadeIn(50);
            })

        }
        else {

            // 固定文本显示
            // $(".mobile_fixTextDiv").css('opacity','1');
            // $(".mobile_fixTextDiv").slideDown(300);


            $("#WebPahPictureAndHideTextArrow-"+index).css('transform','rotate(0deg)');
            // $("#WebPahPictureAndHideTextArrow_circle-"+index).attr('fill', 'none');
            // $("#WebPahPictureAndHideTextArrow_path-"+index).attr('stroke','#5BC0F8');

            sleep(10).then(() => {
                $("#WebPahShowHeadText-"+index).css('display','none');
            })

            sleep(10).then(() => {
                $("#WebPahHideHeadText-"+index).fadeIn(50);
            })

        }
        WebMainPictureAndHideTextClickIndex = index;
    }

    WebPictureAndHideTextOnClick(4);

    startAutoPlayWebPictureAndHideTextOnClick()

    var startWebPictureAndHideTextOnClickSetInterval;

    function startAutoPlayWebPictureAndHideTextOnClick(){
        clearInterval(startWebPictureAndHideTextOnClickSetInterval);
        startWebPictureAndHideTextOnClickSetInterval=setInterval(function () {
            // var activeLink = $('.WebVideoListDiv .WebVideoDiv');
            var activeLink = $('.WebVideoListDiv .WebHideAndShowPicture');
            // console.log("================================",activeLink.length)
            WebMainPictureAndHideTextClickIndex=(WebMainPictureAndHideTextClickIndex+1) % activeLink.length;
            if (WebMainPictureAndHideTextClickIndex==0){
                WebMainPictureAndHideTextClickIndex=activeLink.length
            }
            WebPictureAndHideTextOnClick(WebMainPictureAndHideTextClickIndex);
        },5000)
    }


    function stopAutoPlayWebPictureAndHideTextOnClick(){
        clearInterval(startWebPictureAndHideTextOnClickSetInterval);
    }

    document.onvisibilitychange=function(){
        if(document.visibilityState=="visible"){
            startAutoPlayWebPictureAndHideTextOnClick();
        }else{
            stopAutoPlayWebPictureAndHideTextOnClick();
        }
    }

    $(".WebFuncIntroductionOne").hover(
        function() {
            stopAutoPlayWebPictureAndHideTextOnClick();
        },
        function() {
            startAutoPlayWebPictureAndHideTextOnClick();
        }
    )
    //<!--</editor-fold>-->


    var introductionOneSwiper = new Swiper("#MobFuncIntroductionOneContent", {
        slidesPerView: 'auto',
        spaceBetween: 16,
        touchRatio:1.5,
        pagination: {
            el: ".MobFuncIntroductionOneContentSwiperPagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"><span id="MobFuncIntroductionOneContentModuleSlide-' + index + '" class="MobFuncIntroductionOneContentModuleSlide"> </span></span>';
            },
        },
        on: {
            // transitionEnd: function(){
            //     var index = parseInt(productPurchaseModuleSwiper.realIndex) + 1;
            //     var indexText = index + '/' + $(".MobFuncIntroductionOneContentMoveContentDiv").length;
            //     $(".productPurchaseModuleIndexDiv").html(indexText);
            // },
            // transitionStart:function () {
            // },
            init: function () {
                // 设置新的 slidesOffsetAfter 值
                this.params.slidesOffsetAfter = parseInt($(".MobFuncIntroductionOne .MobFuncIntroductionOneContent").css('padding-left'));
                this.update();
            },
            resize: function(){
                this.params.slidesOffsetAfter = parseInt($(".MobFuncIntroductionOne .MobFuncIntroductionOneContent").css('padding-left'));
                this.update(); //窗口变化时，更新Swiper的一些属性，如宽高等
            }
        }
    });